import React, {Component} from 'react';
import {connect} from 'react-redux'
import FontAwsome from 'react-fontawesome'
import ReactPaginate from 'react-paginate';
import { Box } from 'reactjs-admin-lte'
import ReportStore from '../../stores/ReportStore';
import SubscribeStore from 'stores/SubscribeStore';
import Select from 'react-select'
import {FormControl,Button,ButtonToolbar,DropdownButton,MenuItem} from 'react-bootstrap'
import {Checkbox} from 'react-icheck'
//import ReportBillingNotePopup from './ReportBillingNotePopup'
import ReportWorkTable from './ReportWorkTable'
import ConfirmPopup from '../../component/element/ConfirmPopup'
import TermOfServiceModal from '../tos/TermOfServiceModal'
import AssetWorkDocEntryView from '../tyre/workdoc/AssetWorkDocEntryView'
import 'icheck/skins/all.css';
import './report.css';
const localStorageKey = 'fasttrack.app.version'
const localStorageAcceptKey = 'ckboss_termofuse_accept'
class ReportAssetWork extends Component {

  constructor(...args){
    super(...args)
    var dt = new Date();
    let filter =  (this.props.chassisPrimary!==undefined && this.props.chassisPrimary)?'chassis_no':'car_registration_no'
    this.state = {loading:false,showDetail:false,showField:true,filter:filter,year:dt.getFullYear()*1+543,month:"0",
    activePage:0,itemPerPage:30,pageCount:0,activeMenu:0,query:'',data:[],showBilling:false,showAsst:false,action:'add',work_no:'',
    column_title:[],
    column_index:{}
    }
    //this.onTabClick('all',0)
    let {year,month,showDetail,itemPerPage,query} = this.state
    let apiCall = this.props.autoRefresh?'repairwork':'all'
    this.loadReportWork(apiCall,year,month,showDetail,0,itemPerPage,query,filter,true)
    // console.log('new render reportWork')
    this.checkVersion = true 
  }

  componentWillMount(){
    if(this.props.onRef!==undefined){
      this.props.onRef(this)
    }
  }

  componentDidMount(){
    if(this.props.autoRefresh){
      this.subscribeChannel('reportwork')
    }
  }

  subscribeChannel(channel){
    
    SubscribeStore.subscribeChannel(channel,(jsonObj)=>{      
      console.log('channel recv',jsonObj)
      if(jsonObj.function==='refreshReport'){
        this.refreshReport('repairwork')
      }
      //this.refreshReport()
    })     
  }

  refreshReport(apiCall='all'){
    let {year,month,showDetail,itemPerPage,query,filter} = this.state
    this.loadReportWork(apiCall,year,month,showDetail,0,itemPerPage,query,filter)
    this.setState({activePage:0,activeMenu:0})
  }

  loadReportWork(apiCall,year,month,showDetail,start,length,query,filter,init){
    if(typeof init !=='undefined')
      this.state = Object.assign(this.state,{loading:true})
    else
      this.setState({loading:true})
    
    ReportStore.loadReportAssetWork(apiCall,year,month,showDetail,start,length,query,filter,(result)=>{
      //Laod OK
      if(this.checkVersion){
        this.checkVersion = false
        let cfg = JSON.parse(localStorage.getItem(localStorageKey)) || {version:''}
        let tos = JSON.parse(localStorage.getItem(localStorageAcceptKey)) || {accept:false}
                
        // if(result.bf_app_version!==undefined && cfg.version!==result.bf_app_version){
        //   this.bf_app_version = result.bf_app_version
        //   this.setState({showUpgrade:true})
        // }
        // if(result.bf_app_version!==undefined && cfg.version!==result.bf_app_version){
        //   this.bf_app_version = result.bf_app_version
        //   if(tos.accept){            
        //     this.setState({showUpgrade:true})
        //   }else{
        //     this.refs.tos.getWrappedInstance().loadData()
        //   }          
        // }      
      }
      let column_title = result.column_title.map((item,index)=>{
        item = Object.assign({seq_no:index+1}, item)
        return item
      })
      this.setState({loading:false,data:result.data,pageCount:result.data_count/length, column_index:result.column_index,column_title:column_title})
    })
  }
  

  onPageChange(apiCall,item){
    // let that = this
    let {itemPerPage,year,month,showDetail,query,filter} = this.state
    this.setState({activePage:item.selected})
    this.loadReportWork(apiCall,year,month,showDetail,item.selected*itemPerPage,itemPerPage,query,filter)
  }

  onTabClick(apiCall,index){
    this.setState({activeMenu:index})
    let {year,month,itemPerPage,showDetail,query,filter} = this.state
    this.loadReportWork(apiCall,year,month,showDetail,0,itemPerPage,query,filter)
  }

  onYearChange(apiCall,e){
    let {month,itemPerPage,showDetail,query,filter} = this.state
    let year = e.value
    this.setState({year:year})
    this.loadReportWork(apiCall,year,month,showDetail,0,itemPerPage,query,filter)
  }

  onMonthChange(apiCall,e){
    let {year,itemPerPage,showDetail,query,filter} = this.state
    let month = e.value
    this.setState({month:month})
    this.loadReportWork(apiCall,year,month,showDetail,0,itemPerPage,query,filter)   
  }

  onFilterChange(e){
    console.log(e)
    let {showField,showDetail,itemPerPage} = this.state
    let filter = e?e.value:''
    if(filter==='export_stock'){
      showField = false
      
      let that = this
      ReportStore.loadReportAssetWorkQuery('',filter,showDetail,function(result){
        //Laod OK
        that.setState({data:result.data,pageCount:result.data_count/itemPerPage,activePage:0})
      })
    }else{
      showField = true
    }
    this.setState({filter:filter,showField:showField})
  }

  onSearchClick(){
    let {query,filter,itemPerPage,showDetail} = this.state
    let that = this
    ReportStore.loadReportAssetWorkQuery(query,filter,showDetail,function(result){
      //Laod OK
      that.setState({data:result.data,pageCount:result.data_count/itemPerPage,activePage:0})
    }) 
  }

  onQueryChange(e){
    // let {filter,itemPerPage} = this.state
    let query = e.target.value
    this.setState({query:query})
    
    // if(query.length==0 || query.length==3 || query.length==5){
    //   let that = this
    //   ReportStore.loadReportAssetWorkQuery(query,filter,function(result){
    //   //Laod OK
    //     that.setState({data:result.data,pageCount:result.data_count/itemPerPage})
    //   }) 
    // }
  }

  onShowDetailChange(apiCall,e,showDetail){
    // console.log('changeDetail',e,showDetail)
    let {year,month,itemPerPage,activePage,query,filter} = this.state
    this.setState({showDetail:showDetail})
    if(showDetail){
      if(query!=='' || filter==='export_stock'){        
        let that = this
        this.setState({loading:true})
        ReportStore.loadReportAssetWorkQuery(query,filter,showDetail,function(result){
          //Laod OK
          that.setState({loading:false,data:result.data,pageCount:result.data_count/itemPerPage,activePage:0})
        })  
      }else{
        this.loadReportWork(apiCall,year,month,showDetail,activePage*itemPerPage,itemPerPage,query,filter)
      }
    }
  }

  onSearchKeyPress(target) {
    if(target.charCode===13){
      let {query,filter,itemPerPage,showDetail} = this.state
      let that = this
      ReportStore.loadReportAssetWorkQuery(query,filter,showDetail,function(result){
        //Laod OK
        that.setState({data:result.data,pageCount:result.data_count/itemPerPage,activePage:0})
      })           
    }
  }

  onBillingReportClick(){
    //alert('กำลังอยู่ในการพัฒนา');
    this.refs.reportBilling.getWrappedInstance().loadInit()
    this.setState({showBilling:true})
  }

  onNewWorkClick(){
    // if (process.env.NODE_ENV === "development") {
    //   alert('click new work')
    // }else{
    //   window.show_work_doc('')
    // }
    this.setState({showAsst:true,action:'add',work_no:''})
  }

  onRowWorkClick(workNo){
    // if (process.env.NODE_ENV === "development") {
    //   alert('click work '+workNo)
    // }else{
    //   window.show_work_doc(workNo)
    // }
    this.setState({showAsst:true,action:'edit',work_no:workNo})
  }


  onUpgradeConfirm(){
    localStorage.setItem(localStorageKey, JSON.stringify({version:this.bf_app_version}))
    window.location.reload(true)
    this.setState({showUpgrade:false})
  }

  onAcceptClick() {
    localStorage.setItem(localStorageAcceptKey, JSON.stringify({accept:true}))
    this.onUpgradeConfirm()
  }

  onClose() {
    this.setState({showAsst:false,action:'add',work_no:''})
    let {year,month,showDetail,itemPerPage,query,filter} = this.state
    let apiCall = this.props.autoRefresh?'repairwork':'all'
    this.loadReportWork(apiCall,year,month,showDetail,0,itemPerPage,query,filter,true)
  
  }

  onUpdateAction(value) {
    this.setState({action:value})
  }

  renderFormSearch(){
    let {filter,query,showField} = this.state
    let {messages} = this.props
    return (
      <form className="navbar-left " style={{marginLeft:'15px'}}>
        <div className="form-group ">
          <div style={{width:'180px',display:'inline-block'}}>
            <Select options={this.getFilterOptions()} value={filter} 
            placeholder={''}
            onChange={this.onFilterChange.bind(this)}
            clearable={false}
            />
          </div>
          <div style={{width:'280px',display:showField?'inline-block':'none'}}>
            <div className="input-group ">
                <FormControl
                value={query}
                placeholder={messages['Search Worksheet']}
                onKeyPress={this.onSearchKeyPress.bind(this)}
                onChange={this.onQueryChange.bind(this)}
                />
                <span className="input-group-btn">
                  <Button className='btn-flat' onClick={this.onSearchClick.bind(this)}><FontAwsome name='search'/></Button>                  
                  
                </span>
            </div>
          </div>
        </div>
      </form>
    )
  }

  getYearOptions(){
    let options = []
    var dt = new Date();
    for(let i=(dt.getFullYear()*1+543);i>=2557;i--){
      options.push({label:i,value:i})
    }
    return options;
  }

  getMonthOptions(){
    let {messages} = this.props
    return [
            {label:messages['All Year'],value:'0'},
            {label:messages['January'],value:'01'},
            {label:messages['February'],value:'02'},
            {label:messages['March'],value:'03'},
            {label:messages['April'],value:'04'},
            {label:messages['May'],value:'05'},
            {label:messages['June'],value:'06'},
            {label:messages['July'],value:'07'},
            {label:messages['August'],value:'08'},
            {label:messages['September'],value:'09'},
            {label:messages['October'],value:'10'},
            {label:messages['November'],value:'11'},
            {label:messages['December'],value:'12'},
          ]
  }

  getFilterOptions(){
    let {chassisPrimary,showContact,messages} = this.props
    let options = 
        [
        {value:'car_registration_no',label:messages['Car Registration']},
        {value:'owner_name',label:messages['Customer']},
        {value:'owner_tel',label:messages['Customer Phone']},
        {value:'work_no',label:messages['Worksheet Number']}
         ]
    if(showContact){
      options.push({value:'contact_name',label:messages['Contact Name']})
      options.push({value:'contact_tel',label:messages['Contact Phone']})
    }

    if(chassisPrimary)
      options.unshift({value:'chassis_no',label:messages['Chassis Number']})
    else
      options.push({value:'chassis_no',label:messages['Chassis Number']}) 

    options.push({value:'export_stock',label:messages['Item Not yet cut stock']})   
    return options
  }



  renderCheckbox(apiCall){
    let {showDetail} = this.state
    let {messages} = this.props
    return (
      <div style={{width:'180px',display:'inline-block',lineHeight:'32px',marginLeft:'15px'}}>
            <Checkbox
              checkboxClass="icheckbox_square-blue"
              increaseArea="20%"
              label={' '+messages['Show Detail']}
              value={showDetail}
              onChange={this.onShowDetailChange.bind(this,apiCall)}
            />
       </div>

    )
  }

  renderSearch(apiCall,index){
    if(this.props.autoRefresh){
      return (<div/>)
    }
    if(index!==0){
      return (<div/>)
    }    
    let {month,year} = this.state
    return (
      <div className="row">
        <div className=" navbar-left" style={{paddingLeft:'15px'}}>
          <div className="form-group search-record">
            <div style={{width:'80px',display:'inline-block'}}>
              <Select value={year} options={this.getYearOptions()} 
              onChange={this.onYearChange.bind(this,apiCall)}  clearable={false}/>
            </div>
            <div style={{width:'180px',display:'inline-block'}}>
              <Select
                clearable={false}
                value={month}
                options={this.getMonthOptions()}
                onChange={this.onMonthChange.bind(this,apiCall)}
                />
            </div>   
          </div>
        </div>
        {this.renderFormSearch()}  
        {this.renderCheckbox(apiCall)}
      </div>
    )
  }

  

  renderPaging(apiCall){
    let {messages} = this.props
    return (
      <div className="commentBox">        
          <ReactPaginate  
                        previousLabel={messages['Previous']}
                        nextLabel={messages['Next']}
                        breakLabel={<a href="">...</a>}
                        breakClassName={"break-me"}
                        pageCount={this.state.pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={2}
                        onPageChange={this.onPageChange.bind(this,apiCall)}
                        containerClassName={"pagination pull-right"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} 
                        forcePage={this.state.activePage}
                        />
        </div>
    )
  }

  renderMenuButton(){
    let {messages} = this.props
    let title = messages['Menu']
    return (
      <ButtonToolbar>
        <DropdownButton bsStyle={'primary'} title={title}  id={`dropdown-basic`}>
          <MenuItem eventKey="1"></MenuItem>
          <MenuItem divider />
          <MenuItem eventKey="4">{messages['Print Bill Statement']}</MenuItem>
        </DropdownButton>
      </ButtonToolbar>
    )
  }

  renderWorkTable(item,index){
    let {data,showDetail,column_index,column_title} = this.state
    let {messages} = this.props
    let showPrintBilling = (typeof this.props.showPrintBilling!=='undefined')?this.props.showPrintBilling:true
    return (
      <Box loading={this.state.loading}>
        <Box.Header border={true}>
          <Box.Title>{item.title} - {item.name}</Box.Title>
          <Box.Tools >
            <Button 
            style={{display:(showPrintBilling)?'block':'none'}}
            bsStyle={'link'} className='bg-maroon'
            onClick={this.onBillingReportClick.bind(this)}
            >
                <FontAwsome name='print'/><span className='icon-text'>&nbsp;{messages['Print Bill Statement']}</span>
            </Button> 
                                   
          </Box.Tools>
        </Box.Header>
        <Box.Body>
          {this.renderSearch(item.apiCall,index)}
          <ReportWorkTable rowClass={item.rowClass} data={data} 
            columnIndex={column_index}
            columnTitle={column_title}
          showStatus={this.props.showStatus}
          showAmount={!this.props.autoRefresh}
          showDetail={showDetail} 
          showDriver={true}
          showWaitForPaymentRemark={false}
          showJobDoneRemark={false}
          chassisPrimary={this.props.chassisPrimary}
          onRowWorkClick={this.onRowWorkClick.bind(this)}/>
          {this.renderPaging(item.apiCall)}
        </Box.Body>

      </Box>
    )
    
  }

  render(){
    let {messages} = this.props
    let {activeMenu,showBilling,showUpgrade} = this.state
    let all_work_table = messages['All Work Table']
    let work_table = messages['Work Table']
    // let delivered = messages['Delivered']

    let repair_work = messages['Repair Work']
    let credit = messages['Credit']
    let cancel_work = messages['Cancel Work']

    let all = messages['All']
    let start = messages['Start']
    let under_repair = 'อยู่ระหว่างงาน'
    // let wait_for_delivery = messages['Wait For Delivery']
    let work_done = messages['Work Done']

    let menu = [{name:all,className:'',icon:'files-o',title:all_work_table,apiCall:'all',rowClass:''},
                {name:start,className:'',icon:'clock-o',title:start,apiCall:'new',rowClass:''},
                {name:under_repair,className:'tab-bg-yellow',icon:'wrench',title:work_table,apiCall:'start',rowClass:'orange-row'},
                {name:work_done,className:'tab-bg-green',icon:'thumbs-o-up',title:work_table,apiCall:'job_done',rowClass:'green-row'},
                {name:cancel_work,className:'tab-bg-red',icon:'ban',title:work_table,apiCall:'junk',rowClass:'red-row'}]
    if(typeof this.props.showStatus!=='undefined' && !this.props.showStatus){
      menu = [
        {name:repair_work,className:'',icon:'files-o',title:all_work_table,apiCall:'all',rowClass:''},
        {name:credit,className:'',icon:'money',title:work_table,apiCall:'credit',rowClass:''},
        {name:cancel_work,className:'tab-bg-red',icon:'ban',title:work_table,apiCall:'junk',rowClass:'red-row'}
      ]
    }
    if(typeof this.props.autoRefresh!=='undefined' && this.props.autoRefresh){
      menu = [{name:repair_work,className:'',icon:'files-o',title:all_work_table,apiCall:'repairwork',rowClass:''}]
    }
    return(
    <div className='col-md-12'>
      <div style={{display:!this.state.showAsst?'':'none'}}>
        <div className='nav-tabs-custom'>
            <ul className="nav nav-tabs" style={{display:(this.props.autoRefresh?'none':'')}}>
            {menu.map((item,index)=>(
                <li key={index} className={(index===activeMenu)?"active":""}>
                <a className={item.className} onClick={this.onTabClick.bind(this,item.apiCall,index)}><FontAwsome name={item.icon}/><span className='icon-text'>&nbsp;{item.name}</span></a>
                </li>  
            ))}
            <li className="box-tools pull-right">
                <Button bsStyle='link' className='btn-box-tool text-large'
                onClick={this.onNewWorkClick.bind(this)}
                >
                <FontAwsome name='plus'/>&nbsp;{messages['Add Worksheet']}</Button>
            
            </li> 
            </ul>
            <div className='tab-content'>
            {
                menu.map((item,index)=>(
                <div key={index} className={'tab-pane '+((index===activeMenu)?"active":"")}>
                    {this.renderWorkTable(item,index)}
                </div>
                ))
            }
            </div>
        </div>      
        {/* <ReportBillingNotePopup ref='reportBilling' show={showBilling} 
        onHide={()=>{this.setState({showBilling:false})}}
        /> */}
        <ConfirmPopup show={showUpgrade} title='แจ้งเตือน'
            confirmTitle='อับเกรดเวอร์ชั่นใหม่' cancelTitle='ยกเลิก' message='ระบบอู่ซ่อมรถ มีโปรแกรมเวอร์ชั่นใหม่ ต้องการอับเกรดหรือไม่?'
            onConfirm={this.onUpgradeConfirm.bind(this)}
            onHide={() => { this.setState({ showUpgrade: false }) }}
            />
        <TermOfServiceModal
            ref='tos'
            onAcceptClick={this.onAcceptClick.bind(this)}
            />
      </div>      
      <div style={{display:this.state.showAsst?'':'none'}}>      
        <AssetWorkDocEntryView
            ref='assetWorkDocEntryView'
            editMode={this.props.editMode}
            show={this.state.showAsst}
            action={this.state.action}
            workNo={this.state.work_no}
            onClose={this.onClose.bind(this)}
            onUpdateAction={this.onUpdateAction.bind(this)}
        />
      </div>  
    </div>)
  }
}

ReportAssetWork.defaultProps = {  
  showStatus : true,
  autoRefresh : false,
  showPrintBilling:false,
  editMode:false
}

export default ReportAssetWork = connect(
  (state) => ({messages: state.message.view.report.ReportAssetWork}),null,null,{withRef:true}
)(ReportAssetWork);





// WEBPACK FOOTER //
// ./src/view/report/ReportAssetWork.js